import React from "react";
import Sticky from "app/StickyNode";
import Link from "next/link";
import styles from "./RightRailAds.module.css";
import NextImage from "@components/Image/NextImage";

const RightRailAds = ({ stickyTop, bottomBoundary }) => {
  const customStyles = {
    flex: "0 0 310px",
    marginLeft: "1rem",
    maxWidth: "310px",
    minHeight: "600px",
    width: "100",
  };
  return (
    <div className={styles.right_rail_noAdsLayout} style={customStyles}>
      <Sticky bottomBoundary={bottomBoundary} top={stickyTop}>
        <Link href="/newsletters-2">
          <NextImage
            ImageUrl={`${process.env.S3_IMAGE_URL}/EBB_NL_Signup_Sidebar_Design.png`}
            alt="Subscribe to EBB"
            title="Subscribe to EBB"
            width={310}
            height={400}
            layout="responsive"
            isLazyload={true}
          />
        </Link>
      </Sticky>
    </div>
  );
};

export default React.memo(RightRailAds);
